import { useEffect, useState } from 'react';
import type { MailEinstellungen } from '@beholder/shared/module/mail';
import type { ModulSeiteProps } from '../../core/modul';
import { api, modulPfad } from '../../core/api';
import { Eingabe, Feld, Karte, Knopf, Laden, Meldung, useAktion, useDaten } from '../../core/ui';
import { PlusAdressen } from './gemeinsam';

export function Einstellungen({ projekt, beiAenderung }: ModulSeiteProps & { beiAenderung(): void }) {
  const pfad = modulPfad(projekt.id, 'mail', 'einstellungen');
  const { daten, setDaten, fehler } = useDaten(() => api.get<MailEinstellungen>(pfad), [pfad]);
  const [kuerzel, setKuerzel] = useState('');
  const [notiz, setNotiz] = useState(true);
  const [ok, setOk] = useState('');
  const a = useAktion();
  useEffect(() => {
    if (daten) {
      setKuerzel(daten.kuerzel ?? '');
      setNotiz(daten.mindmapNotiz);
    }
  }, [daten]);

  if (fehler) return <Meldung>{fehler}</Meldung>;
  if (!daten) return <Laden />;
  const darf = projekt.verwalten && !projekt.archiviert;

  return (
    <div className="stapel" style={{ maxWidth: 720 }}>
      <Karte titel="Mail-Einstellungen des Projekts">
        <div className="stapel">
          <Feld
            titel="Kürzel für die Plus-Adresse"
            hinweis={
              daten.plusAdressen.length ? (
                <>
                  Mails an <PlusAdressen adressen={daten.plusAdressen} /> landen automatisch in diesem Projekt. Das Kürzel gilt für jedes Postfach.
                </>
              ) : (
                'Mails an name+kürzel@gmail.com landen automatisch in diesem Projekt. 2–30 Zeichen: a–z, 0–9, Bindestrich.'
              )
            }
          >
            <Eingabe value={kuerzel} disabled={!darf} onChange={(e) => setKuerzel(e.target.value)} placeholder="z. B. sommerfest" maxLength={30} />
          </Feld>
          <label className="schalter">
            <input type="checkbox" checked={notiz} disabled={!darf} onChange={(e) => setNotiz(e.target.checked)} />
            <span>
              Zusammenfassungen automatisch an den passenden Mindmap-Punkt hängen
              <br />
              <span className="leise klein">Rechnungen, Kostenvorschläge und Aufgaben werden immer nur als Vorschlag angelegt.</span>
            </span>
          </label>
          <Meldung>{a.fehler}</Meldung>
          <Meldung art="ok">{ok}</Meldung>
          {darf ? (
            <div>
              <Knopf
                art="haupt"
                disabled={a.laeuft}
                onClick={async () => {
                  setOk('');
                  const r = await a.ausfuehren(() => api.put<MailEinstellungen>(pfad, { kuerzel: kuerzel.trim() || null, mindmapNotiz: notiz }));
                  if (r) {
                    setDaten(r);
                    setOk('Gespeichert');
                    beiAenderung();
                  }
                }}
              >
                Speichern
              </Knopf>
            </div>
          ) : (
            <p className="leise klein">Nur die Projektleitung kann das ändern.</p>
          )}
        </div>
      </Karte>
    </div>
  );
}
